import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {DagSourceModel} from "@app/workflow-common/services/DagSourceModel";
import {TriggerDatasetService} from "@app/workflow-common/services/trigger-dataset.service";

@Component({
  selector: 'app-conditional-edge2',
  templateUrl: './conditional-edge.component.html',
  styles: []
})
export class ConditionalEdgeComponent implements OnInit {

    @Input() form: FormGroup;
    @Input() dagSourceModel: DagSourceModel;
    @Input() conditionalColName: string;
    @Input() isReadOnlyMode: boolean = false;
    @Input() blockObject;

    select2Instance: any = null;
    conditionForm: FormGroup;
    isEdit: boolean = false;
    dataFunction = function(item){ return item.text; };

    activeConditionalField: {
        text: string,
        input: string,
        operators: any;
        options?: any[]
    } = undefined;
    operators:object = {};

    constructor(
        private triggerService: TriggerDatasetService,
        private _formBuilder: FormBuilder,
    ) { }

    ngOnInit() {
        const fields = this.dagSourceModel.getFieldMetadata();
        let formData = {
            operator: '',
            value: ''
        };
        const { condition } = this.blockObject;
        if(condition) {
            this.isEdit = true;
            formData.operator = condition['operator'];
            formData.value = condition['value'];
        }
        this.activeConditionalField = fields[this.conditionalColName];
        this.operators = this.triggerService.getOperators();
        this.conditionForm = this.formGroup();
        this.conditionForm.addControl('operator', new FormControl(formData.operator, [Validators.required]));
        this.conditionForm.addControl('value', new FormControl(formData.value, [Validators.required]));
        this.conditionForm.addControl('col_name', new FormControl(this.conditionalColName));
        this.conditionForm.addControl('text', new FormControl(this.activeConditionalField['text']));
        this.conditionForm.addControl('type', new FormControl(this.activeConditionalField['type']));
        this.conditionForm.addControl('fieldType', new FormControl(this.activeConditionalField['fieldType']));
        this.conditionForm.addControl('pageType', new FormControl(this.activeConditionalField['pageType']));
    }
    formGroup() {
        return this.form.get('condition') as FormGroup
    }

    onSelectOperator() {
        const formGroup = this.formGroup();
        formGroup.get('value').setValue('')
        if(this.select2Instance) {
            this.select2Instance.select2('destroy');
        }
    }

    onSelectMultipleSelect(event: any) {
        this.formGroup().get('value').setValue(event);
    }

    setSelect2Instance($instance) {
        this.select2Instance = $instance;
    }
}
